<template>
    <li v-if="item && ((item.width_size && item.height_size) ||(item.width_size && item.length_size)|| item.pattern)">
        <span>Size:</span>
        <span v-if="item.pattern">{{ item.pattern }}</span>
        <span v-else-if="item.width_size && item.height_size">{{ item.width_size }} X {{ item.height_size }}</span>
        <span v-else-if="item.width_size && item.length_size">{{ item.width_size }} X {{ item.length_size }}</span>
    </li>
</template>
<script>
export default {
    name:'ItemSize',
    props: ["item"]
};
</script>
